import React from 'react';
import './InlineNotification.scss';
import { WarningNotification, ErrorNotification, SuccessNotification, InfoNotification } from '../../constants/SvgIcons';

type NotificationType = 'warning' | 'error' | 'success' | 'info';

interface InlineNotificationProps {
  type: NotificationType;
  title: string;
  description?: string;
  failedTryDescription?: string;
  onTryAgain?: () =>  Promise<void>;
  attempts?: number;
}

const icons = {
  warning: (<WarningNotification className='inline-notification-icon'/>),
  error: (<ErrorNotification className='inline-notification-icon'/>),
  success: (<SuccessNotification className='inline-notification-icon'/>),
  info: (<InfoNotification className='inline-notification-icon'/>)
};

  
const InlineNotification: React.FC<InlineNotificationProps> = ({
  type,
  title,
  description,
  failedTryDescription,
  onTryAgain,
  attempts
}) => {
  if (!attempts) {
    attempts = 0;
  }
  const handleTryAgain = async () => {
    console.log('try again attenpts', attempts);
      onTryAgain && onTryAgain();
  }
            


  return (
    <div className={`inline-notification ${type}`}>
      {icons[type]}
      <div className="inline-notification-content">
        <strong className="inline-notification-title">{title}</strong>
        {description && attempts < 3 && <p className="inline-notification-description">{description}</p>}
        {failedTryDescription && attempts >= 3 && <p className="inline-notification-description">{failedTryDescription}</p>}
   
      </div>
      {onTryAgain && attempts < 3 && (
        <button onClick={handleTryAgain} className="inline-notification-button">
          Try Again
        </button>
      )}
    </div>
  );
};

export default InlineNotification;